import { render, staticRenderFns } from "./OwnershipNoticeModal.vue?vue&type=template&id=a0f9df98&scoped=true"
import script from "./OwnershipNoticeModal.vue?vue&type=script&lang=js"
export * from "./OwnershipNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./OwnershipNoticeModal.vue?vue&type=style&index=0&id=a0f9df98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f9df98",
  null
  
)

export default component.exports